module.exports = __webpack_public_path__ + "static/img/tik.ca53ae3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/tik.jpg
// module id = Td5z
// module chunks = 0